<template>
  <v-card class="pa-4">
    <v-card-title class="pa-0 mb-3">
      Ostatnie zmiany
    </v-card-title>
    <div
      v-for="(change, index) in history.changes"
      :key="index"
      class="py-2"
    >
      <p
        class="text-subtitle-2 mb-1"
        v-html="change.text"
      />
      <p class="text-caption mb-0">
        {{ change.createdAt | timestamp }}
      </p>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    history: {
      type: Object,
      required: true,
    },
  },
};
</script>
